import { createSlice } from '@reduxjs/toolkit'

const userSlice = createSlice({
    name: 'user',
    initialState: {},
    reducers: {
        setUser(state, action) {
            const { payload } = action

            return { ...state, ...payload }
        },
        removeUser() {},
        getUser() {},
        getUserSuccess() {},
        getUserError() {},
    },
})

const { actions, reducer } = userSlice

export const { setUser, removeUser, getUser, getUserSuccess, getUserError } = actions

export default reducer
